module.exports = __webpack_public_path__ + "static/media/News02.52327517.jpg";